var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-wrapper"},[_c('b-tabs',{attrs:{"lazy":""}},[_c('b-tab',{attrs:{"title":"Source"}},[_c('ulu-customers-source-chart')],1),_c('b-tab',{attrs:{"title":"Churn"}},[_c('ulu-customers-churn-chart')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }